import { Component, OnInit } from '@angular/core';
import { httpService } from '../components/body.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { ThrowStmt } from '@angular/compiler';

@Component({
  selector: 'app-datosaf',
  templateUrl: './datosaf.component.html',
  styleUrls: ['./datosaf.component.css']
})
export class DatosafComponent implements OnInit {

  paciente: any;
  cargado: boolean = false;
  descripcion = '';

  constructor( public http: httpService, public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
   }


  ngOnInit() {
       this.cargado = true;
  }

  grabarPaciente() {
    /*
    this.paciente.apapf = [{ fecha: Date.now(), descripcion: this.descripcion}];
    this.http.updatePaciente(this.paciente).subscribe( paciente => {
      if (paciente.status === 'ok') {
        this.http.pacienteactual = this.paciente;
        this.http.cargarPacientes().subscribe( paciente => {
          this.http.pacientes = paciente.message;
          this.http.paginaactual = 'datosusuario';
      })
    } else {
        this.toastr.warning('Error al grabar datos, compruébelos', 'Grabar Paciente')
      }
      
  })*/
  }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/Angular/Urbanos/src/app/datosaf/datosaf.component.ts